import $ from "jquery";
import {$body, CLEAN_URL} from '../../../Constants';
import HtmlElement from '../../../Elements/HtmlElement';

/**
 * Notepad
 */
const Notepad = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		NOTEPAD: '.meta-bar .notepad',
		NOTEPAD_FORM: '#mzinv',
		ADD_ARTICLE: 'button.note-article',
		ADD_ARTICLE_TANKFINDER: '.advisor-article-content a.notepad',
		REMOVE_ARTICLE: '.notepad-remove',
		CONTENT: '.notepad-content',
		ARTICLE: '.notepad-item',
		NOTEPAD_TOGGLE: '.meta-bar .notepad .button',
		NOTEPAD_COUNT: '.notepad-count'
	};

	/**
	 * Notepad
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class Notepad extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();

			this._articlesVisible = false;
			this._addButtonClicked = false;

			this._saveArticle();
			this._removeArticle();
			this._updateNotepad();
			this._toggleArticles();

			this._loadNotepadForm();
		}

		_saveArticle() {
			$body.on('click', Selector.ADD_ARTICLE, e => {
				this._addButtonClicked = true;
				this._updateArticle(e.currentTarget, 3410, false);
			});
			$body.on('click', Selector.ADD_ARTICLE_TANKFINDER, e => {
				// Follow link AFTER ajax call
				e.preventDefault();
				this._updateArticle(e.currentTarget, 3410, true);
			});
		}

		_removeArticle() {
			$body.on('click', Selector.REMOVE_ARTICLE, e => {
				this._updateArticle(e.currentTarget, 3412, false);
			});
			this._loadNotepadForm();
		}

		_updateArticle(currentTarget, typeNum, tankfinder) {
			let articleUid = $(currentTarget).data('uid');
			if (articleUid > 0) {
				$.ajax({
					type: 'GET',
					url: CLEAN_URL + '?type=' + typeNum + '&uid=' + articleUid,
					success: () => {
						this._updateNotepad();
						// Follow supplier link AFTER ajax call for tankfinder button
						if (tankfinder) {
							window.location = $(currentTarget).attr('href');
						}
					}
				});
			}
		}

		_updateNotepad() {
			$.ajax({
				type: 'GET',
				url: CLEAN_URL + '?type=3411',
				success: (response) => {
					const $notepadForm = $body.find('.notepad-form');

					if (!$body.find(Selector.CONTENT).length && $(response).length) {
						this._articlesVisible = false;
						$body.find(Selector.NOTEPAD).replaceWith(response);

						if (this._addButtonClicked) {
							this._showArticles();

							setTimeout(() => {
								this._hideArticles();
							}, 3000);
						}
					} else {
						const $response = $(response);
						const $articles = $response.find(Selector.CONTENT);
						const $items = $response.find(Selector.ARTICLE);

						if ($items.length === 0) {
							// $body.find(Selector.NOTEPAD).empty();
							$body.find(Selector.NOTEPAD_COUNT).text(0);
							$body.find(Selector.CONTENT).remove();

							if ($notepadForm.length) {
								$notepadForm.parent('.notepad-form-wrap').remove();
							}
						} else {
							$body.find(Selector.NOTEPAD_COUNT).text($items.length);
							$body.find(Selector.CONTENT).replaceWith($articles.clone());

							if ($notepadForm.length) {
								this._loadNotepadForm();
							}

							this._showArticles();

							setTimeout(() => {
								this._hideArticles();
							}, 3000);
						}
					}
				}
			})
		}

		_loadNotepadForm() {
			if ($body.find(Selector.NOTEPAD_FORM).length > 0 || $body.find('.notepad-form').length > 0) {
				$.ajax({
					type: 'GET',
					url: CLEAN_URL + '?type=3415',
					success: (response) => {
						if ($body.find(Selector.NOTEPAD_FORM).length > 0) {
							$body.find(Selector.NOTEPAD_FORM).replaceWith(response);
						} else {
							$body.find('.notepad-form').html($('<div />').html(response).find('.notepad-form').contents());
						}
					}
				});
			}
		}

		_toggleArticles() {
			$body.on('click', Selector.NOTEPAD_TOGGLE, () => {
				if (this._articlesVisible) {
					this._hideArticles();
				} else {
					this._showArticles();
				}
			});
		}

		_showArticles() {
			$body.find(Selector.CONTENT).stop(true, false).fadeIn();
			this._articlesVisible = true;
		}

		_hideArticles() {
			$body.find(Selector.CONTENT).stop(true, false).fadeOut();
			this._articlesVisible = false;
		}
	}

	return Notepad._getElement($body.find(Selector.NOTEPAD), Notepad);
})();

export default Notepad;
